//Api

const Local = 
    {
        api: {
            base_url:  "http://gemini.test/api/v1/", 
            code: "THeLS258MVapu2mYT6PW61r2W"
        }
    }


export default Local;